import { render, staticRenderFns } from "./PopupTextSubHeading.vue?vue&type=template&id=2e8aaa16&scoped=true"
import script from "./PopupTextSubHeading.vue?vue&type=script&lang=js"
export * from "./PopupTextSubHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8aaa16",
  null
  
)

export default component.exports